const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLvl62IconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.95,16.41s0,0,0,0c0,0,0,0-.01-.01,0,0-.01-.01-.02-.02h0s-.02-.02-.03-.03c0,0,0,0-.02-.01,0,0-.01,0-.01-.01-.02-.01-.04-.03-.06-.04-.08-.04-.18-.09-.31-.13-.09-.03-.18-.05-.26-.08-.1-.03-.21-.05-.33-.08-.36-.08-.8-.15-1.31-.21-.38-.05-.76-.09-1.14-.12-.42-.04-.87-.07-1.34-.1h0c-1.1-.07-2.33-.12-3.64-.14-.11,0-.23,0-.34,0-.74,0-1.48,0-2.22,0-.11,0-.23,0-.34,0-1.31.02-2.54.07-3.64.14h0c-.66.04-1.28.09-1.83.15-.95.1-2.01.24-2.6.46-.3.11-.47.22-.47.33,0,.57,3.89,1.03,8.89,1.09v-1.64c.74,0,1.48,0,2.22,0v1.64c5-.06,8.89-.53,8.89-1.09,0-.03-.01-.07-.04-.1h0Z",
    style: {
      fill: "#060101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.85,11.74s0,0,0,0c0,0-.01-.02-.02-.03-.09-.12-.22-.21-.35-.3-.6-.39-1.68-.73-3.09-.99-1.62-.31-3.46-.46-5.28-.5-.75-.02-1.5-.01-2.22,0h0c-2.47.06-4.66.31-6.25.69-.78.18-1.58.44-2.09.77,0,0-.02,0-.02.02,0,0-.01,0-.02.02C.18,11.64,0,11.87,0,12.11,0,13.24,3.89,14.18,8.89,14.3v-3.83c.37,0,.74,0,1.11,0,.37,0,.74,0,1.11,0v3.83c5-.12,8.89-1.05,8.89-2.19,0-.13-.05-.25-.14-.37h0Z",
    style: {
      fill: "#060101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89,8.78V.57c.77-.03,1.52-.03,2.22,0v8.21c5-.24,8.89-2.11,8.89-4.38,0-1.57-1.86-2.94-4.66-3.72C14.01.3,12.57.09,11.11.02c-.74-.03-1.49-.03-2.22,0h0C6.11.16,3.68.8,2.06,1.72c-.6.34-1.14.75-1.53,1.25-.35.45-.54.93-.54,1.43,0,2.27,3.89,4.13,8.89,4.38h0Z",
    style: {
      fill: "#060101"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl62IconBlack);
export default __webpack_public_path__ + "static/media/lvl-62-icon-black.49eb8402c27636cc45ffb2035991bc89.svg";
export { ForwardRef as ReactComponent };